__turbopack_context__.v({
  "forced-error": "_2dFDLa_forced-error",
  "label": "_2dFDLa_label",
  "text": "_2dFDLa_text",
  "wrapper": "_2dFDLa_wrapper",
});
